import transcodingStatuses from '../../constants/transcoding-statuses';
import channels from './channels/channels';

const itemsTranscodingStatuses = {};

const LISTENER_NAME = 'transcoding';

const TRANSCODING_PROGRESS_STATUSES = [
  transcodingStatuses.IN_QUEUE,
  transcodingStatuses.PENDING,
  transcodingStatuses.INPROGRESS,
  transcodingStatuses.PREVIEW_READY,
];


function isNotInTranscoding(transcodingStatus) {
  return !_.includes(TRANSCODING_PROGRESS_STATUSES, transcodingStatus);
}

export default function triggerProgressWhileTranscoding(items) {
  // TODO: handle small files uploading

  if (items) {
    if (_.every(items, function ({ transcodingStatus, trailerTranscodingStatus }) {
        return isNotInTranscoding(transcodingStatus) && isNotInTranscoding(trailerTranscodingStatus);
      })) {
      return;
    }

    _.forEach(items, function ({ mediaFileName, trailerFileName, transcodingStatus, trailerTranscodingStatus }) {
      if (mediaFileName) {
        itemsTranscodingStatuses[mediaFileName] = transcodingStatus;
      }
      if (trailerFileName) {
        itemsTranscodingStatuses[trailerFileName] = trailerTranscodingStatus;
      }
    });
  }

  channels.startListen(LISTENER_NAME);
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/trigger-progress-while-transcoding.js